/**
 * Created by aaikepae on 2/13/17.
 */
import axios from "axios";

export function getLatestContent(jivename, type, count = 10) {
  return new Promise(function (resolve, reject) {
    getContentID(jivename, type).then((jiveID) => {
      getLatestContentByID(jiveID, type, count).then((response) => {
        resolve(response)
      })
    }).catch(error => {
      reject()
    })
  })
}

export function getContentID(jivename, type) {
  if (!jivename || !type) {
    return;
  }


  const placesSearchAPi = PubHub.communityAPIHost + "/api/core/v3/search/places";
  return new Promise(function (resolve, reject) {
    axios.get(`${placesSearchAPi}?filter=search(${jivename})&filter=nameonly`).then(response => {

      const fn = (list) => {

        if (!list.length) {
          reject()
        }

        let id;

        let item = null;

        // if more than 2 items
        if (list.length > 2) {
          const parentPlaceName = jivename.toLowerCase() == 'devnet' ? 'Cisco Communities' : 'DevNet';
          const matchedItems = list.filter((item) => item.parentPlace.name == parentPlaceName);
          item = matchedItems[0];

        } else {
          item = list[0];
        }

        // if there is not item
        if (!item) {
          reject()
        }


        if (type === 'blog' && item.resources["blog"]) {
          id = parseInt(item.resources.blog.ref.split("/places/").pop());// get the id, blog's id is different
        } else if (type === "event") {
          id = parseInt(item.parent.split("/places/").pop());
        } else {
          id = parseInt(item.resources.activity.ref.split("/places/").pop());
        }
        // call resove for promiss
        resolve(id);
        return id;
      };


      if (response.data && response.data.list && response.data.list.length) {
        return fn(response.data.list)
      }


      reject()

    }).catch(error => {
      reject()
    })
  })
}


export function getLatestContentByID(id, type, count = 10) {
  return new Promise(function (resolve, reject) {resolve({})});
//   const jiveContentsAPI = PubHub.communityAPIHost + "/api/core/v3/contents";
//   const _type = type === "blog" ? "post" : type;
//   const APIURL = `${jiveContentsAPI}?filter=type(${_type})&filter=place(/jive/api/core/v3/places/${id})`;
//   return new Promise(function (resolve, reject) {
//     axios.get(APIURL, {
//       params: {
//         sort: "dateCreatedDesc",
//         startIndex: 0,
//         count: count,
//         abridged: true
//       }
//     }).then((response) => {

//       response.data = {results: response.data}
//       resolve(response.data)
//     }).catch(() => {
//       reject()
//     });
//   })
}
